<template>
  <div>
    <div class="container">
      <div
        class="columns is-gapless device-room-count"
        v-if="countDeviceStatus">
        <div class="column column-break">
          <div class="field is-grouped is-grouped-multiline">
            <div class="control">
              <span class="tags has-addons">
                <span class="tag">INCALL</span>
                <span class="tag is-link">{{countDeviceStatus.incall}}</span>
              </span>
            </div>
            <div class="control">
              <span class="tags has-addons tag-online">
                <span class="tag">ONLINE</span>
                <span class="tag is-success">{{countDeviceStatus.online}}</span>
              </span>
            </div>
            <div class="control">
              <span class="tags has-addons">
                <span class="tag">OFFLINE</span>
                <span class="tag is-light">{{countDeviceStatus.offline}}</span>
              </span>
            </div>
            <div class="control">
              <div @click="reloadDevices()" class="button-reload-device"><b-icon icon="redo"></b-icon></div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns device-room-list is-gapless has-text-weight-bold is-mobile has-line">
        <div class="column column-break has-text-weight-bold order">STT</div>
        <div class="column column-break has-text-weight-bold">Trạng thái</div>
        <div class="column column-break has-text-weight-bold">Điểm cầu</div>
        <div class="column column-break has-text-weight-bold">Chế độ</div>
        <div class="column column-break has-text-weight-bold">H323</div>
        <div class="column column-break has-text-weight-bold">Dial string</div>
        <div class="column column-break has-text-weight-bold last-column">Kết nối</div>
      </div>

      <div class="columns device-room-list is-gapless is-mobile" v-for="(device, index) in deviceList" :key="index">
        <div class="column column-break order">{{index+1}}</div>
        <fragment v-if="device">
          <div class="column column-break">
          <fragment v-if='device.device === "INCALL"'>
            <span class="button is-link">{{device.device}}</span>
          </fragment>
          <fragment v-if='device.device === "ONLINE"'>
            <span class="button is-success">{{device.device}}</span>
          </fragment>

          <fragment v-if='device.device === "OFFLINE"'>
            {{device.device}}
          </fragment>
          
          
          </div>
          <div class="column column-break">{{device.endpointName}}</div>
          <div class="column column-break">{{coverToString(device.mode)}}</div>
          <div class="column column-break">{{coverToString(device.h323)}}</div>
          <div class="column column-break">{{coverToString(device.dialstring)}}</div>
          <div class="column column-break last-column">
            <fragment v-if='device.device === "ONLINE"'>
              <div class="field is-grouped">
                <div class="control control-required">
                  <v-select class="room-list-select" label="roomIdentifier" :options="roomList" @input="(evt) => updateRoomByDevice(evt, index)"></v-select>
                </div>
                <div class="control">
                  <button class="button is-info button-connect" @click="connectDevice(device)">Kết nối</button>
                </div>
              </div>
            </fragment>
          </div>
        </fragment>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState } from "vuex";
  import { Fragment } from "vue-fragment";
  import vSelect from "vue-select"

  Vue.component('v-select', vSelect)

const ONLINE_STATUS = 'online'
const OFFLINE_STATUS = 'offline'
const INCALL_STATUS = 'incall'

export default {
  data() {
    return {
      nameList: [],
      participants: [],
      deviceList: [],

      intervalLoadDevices: null
    };
  },
  components: { Fragment },

  created() {
    
    this.getParticipants(this.$store.state.auth.entityTag).then(res => {
      this.participants = res.map(e => e.name);
        this.fetchDevicesByUser(this.participants).then((_res) => {
        
        this.deviceList = _res.data.devices;
        this.initSelectedRoom()
      });

    })

  },
  methods: {
    ...mapActions("hostDevice", ["fetchDevicesByUser"]),
    ...mapActions("participant", ["getParticipants"]),
    ...mapActions("room", ["setDialOut", "getConferenceIdList"]),

    initSelectedRoom() {
      this.deviceList = [...this.deviceList.map(device => {
        device.selectedRoom = null
        return device
      })]
    },

    reloadDevices() {
      this.fetchDevicesByUser(this.participants).then((_res) => {
        
        this.deviceList = _res.data.devices;
      });
    },

    coverToString(data) {
      if(data) return data.toString();
    },
    
    connectDevice(device) {
      const checkedStartRoom = this.startRoom(device.selectedRoom)
      if(checkedStartRoom) {
        checkedStartRoom.then(() => {
          const searchedMeeting = this.$store.state.room.conferenceIdentityList.find(meeting => {
            return meeting.roomId === device.selectedRoom.roomIdentifier
          })
          this.setDialOut({
            name: device.deviceId,
            text: device.dialstring,
            type: "sip",
            conferenceId: searchedMeeting.conferenceId
          }).then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: `Kết nối "${device.endpointName}" thành công`,
                type: "is-info"
              });
                
            } else {
              this.$toast.open({
                type: "is-danger",
                message: "Xin lỗi, kết nối với thiết bị không thành công. Có thể phòng họp chưa được start"
              });
            }
  
            setTimeout(()=> {
              this.fetchDevicesByUser(this.participants).then((_res) => {
                this.deviceList = _res.data.devices;
                this.initSelectedRoom()
              });
            }, 2000)
            
          }).catch(() => {
            setTimeout(()=> {
              this.fetchDevicesByUser(this.participants).then((_res) => {
                this.deviceList = _res.data.devices;
                this.initSelectedRoom()
              });
            }, 2000)
          })
        })
      }
      
    },
    startRoom(room) {
      if(room) {
        const { roomIdentifier } = room;
        this.isLoadButtonStart = true;
        return this.$store
          .dispatch("room/startConference", roomIdentifier)
          .then(res => {
            if (res.data.status == 409) {
              return this.getConferenceIdList({roomIds: this.roomList.map(room => room.roomIdentifier)});
            } else {
              return res
            }
          })
          .finally(() => (this.isLoadButtonStart = false));
      } else {
        this.$toast.open({
          message: "Vui lòng chọn phòng họp để khởi động",
          type: "is-danger"
        });
        return null
      }
    },
    updateRoomByDevice(evt, index) {
      this.deviceList[index].selectedRoom = evt
    }

  },

  computed: {
    ...mapState("hostDevice", ["devices"]),
    ...mapState("room", ["roomList"]),
    countDeviceStatus() {
      return this.deviceList.reduce((accumulate, current) => {
        if(current.device) {
          accumulate[current.device.toLowerCase()] += 1
        }
        return accumulate
      }, {[ONLINE_STATUS]: 0, [OFFLINE_STATUS]: 0, [INCALL_STATUS]: 0})
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/partials/_colors.scss";
@import "vue-select/src/scss/vue-select.scss";
img.loading {
  display: inline-block;
}
.o-centered {
  text-align: center;
}
.mt20 {
  margin-top: 30px;
  padding-bottom: 15px;
}
.columns.device-room-list.is-gapless:not(:last-child) {
  margin-bottom: 0;
}
.device-room-list {
  padding: 10px 6px;
  &.columns:nth-child(2n+2) {
    background-color: rgba(0, 0, 0, 0.1)!important;
  }
}
.device-room-count.columns.is-gapless {
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 15px;
}
.roomList__address-form {
  .label {
    font-size: 14px;
  }
}
.v-select {
  &.room-list-select {
    display: inline-block;
    vertical-align: middle;
    width: 125px;
  }
}
.column-break {
  word-break: break-word;
}
.vs__dropdown-toggle {
  padding-bottom: 2px;
}
.last-column.column {
  flex-basis: 65px;
}
.button-reload-device {
  cursor: pointer;
}
.tag-online {
  .tag:not(body).is-success {
    background-color: $green;
  }
}
.button.is-success {
  background-color: #14afb4;
}
.order {
  max-width: 50px;
}
</style>
